import { eventDispatcherForFunctionalComponents, scrollWidget } from '../../conversational-search-logic/utils/utils';
import type { WidgetConversationalSearchChatWidgetBody } from './chat-widget-body';

export const scrollHandler = (element: HTMLElement, scrollTimeout: number) => {
    const chatContainerClass = '.conversational-search-chat-widget-body-elements';
    const componentToFind = 'uiaas-search-conversational-search-messages-wrapper';
    const chatContainer = element.shadowRoot.querySelector(chatContainerClass);

    scrollTimeout = scrollWidget(chatContainer, componentToFind);
};

export const handlechatQueryChanges = (context: WidgetConversationalSearchChatWidgetBody, textAreaValue) => {
    context.chatQuery = textAreaValue;
    context.chatQueryIndex++;
    context.chatQueryEventEmitter.emit({ query: context.chatQuery });
};

export const getUserQuestion = (context: WidgetConversationalSearchChatWidgetBody, clickedArea: string) => {
    const input = context.el.shadowRoot.querySelector('qds-input') as HTMLTextAreaElement;

    if (!input?.value?.trim()) return (context.isInputErrorVisible = true);

    context.isInputErrorVisible = false;
    handlechatQueryChanges(context, input?.value);
    eventDispatcherForFunctionalComponents('conversational-search:ga-input', {
      keyword: input.value,
      clickedArea: clickedArea,
      eventName: 'search',
      action: 'click',
      location: 'genAI_search',
      site_search_category:'GenAI search',
      site_search_keyword:  input.value,
    });

    input.value = '';
};

export const sendClickHandler = (context: WidgetConversationalSearchChatWidgetBody, isTextAreaDisabled: boolean) =>
  !isTextAreaDisabled ? getUserQuestion(context, 'icon') : void 0;

export const keyPressHandler = (context: WidgetConversationalSearchChatWidgetBody, e) => {
    context.isInputErrorVisible = false;

    if (e.key === 'Enter') {
      e.preventDefault();
      getUserQuestion(context, 'textarea');
      e.target.value = '';
    }
};

export const modifyInputValue = (element: HTMLElement, value: string = '') => {
    (element.shadowRoot.querySelector('qds-input') as HTMLTextAreaElement).value = value;
};
